import {
    ALL_CATEGORIES, ALL_MERCHANTS
} from './types'

export const setAllCategories = (data) => {
    console.log("COming in set all categories reducer")
    return {
        type: ALL_CATEGORIES,
        payLoad: data
    }
}
export const setAllMerchants = (data) => {
    return {
        type: ALL_MERCHANTS,
        payLoad: data
    }
}
